module.exports = __webpack_public_path__ + "img/ic_order_wait_off.50f3ae16.png";